import styles from './ModPanel.module.css';
import { ModState } from '../../../features/Mod/types/mod';
import ModElement from './ModElement';
import { useAtomValue } from 'jotai';
import { sortedModsAtom } from '../../../features/Mod/modStore';
import { useEffect } from 'react';
import { modService } from '../../../features/Mod/modService';

const modsUpdateInterval = 5000;

const ModPanel = () =>
{
	const sortedMods = useAtomValue(sortedModsAtom);

	useEffect(() =>
	{
		let timeoutId: number | null = null;
		let isMounted = true;

		const listMods = async () =>
		{
			modService.list()
				.catch(error =>
				{
					if (error?.name !== "AbortError")
					{
						console.error("Error:", error);
					}
				})
				.finally(() =>
				{
					if (isMounted)
					{
						timeoutId = setTimeout(listMods, modsUpdateInterval);
					}
				});
		};

		// ServerDashboardView handles initial fetch; start polling after interval
		timeoutId = setTimeout(listMods, modsUpdateInterval);

		return () =>
		{
			isMounted = false;
			if (timeoutId !== null)
			{
				clearTimeout(timeoutId);
			}
		};
	}, []);

	return (
		<div className={styles.container}>
			<div className={styles.actions}>
				<div>
					{/* <Select title={'Test'} options={[
						{ key: 'required-mods', value: 'Required mods' },
						{ key: 'server-mods', value: 'Server mods' },
						{ key: 'optional-mods', value: 'Optional mods' }
					]} /> */}
					<div>{sortedMods.filter(mod => mod.state == ModState.Selected).length} mods loaded</div>
				</div>
				{/* <Checkbox label='Load all' /> */}
			</div>
			<div className={styles.list}>
				{sortedMods.map(mod => <ModElement key={mod.id} mod={mod} />)}
			</div>
		</div>
	);
};

export default ModPanel;
